import { useEffect, useRef, useState } from 'react';
import styles from './CreateNewTypeComponent.module.css'
import AddIcon from '@mui/icons-material/Add';
import { Button } from '@mui/material';

interface CreateNewTypeComponentProps {
    onCreateTitle: (type: string) => void
    onCreateDescription: (type: string) => void
    onUploadImageClick: (type: string) => void
    onUploadPdfOrWord: (type: string) => void
    enviarAudio: (type: string) => void
    existeComponente: boolean
}

export function CreateNewTypeComponent({ onCreateTitle, onCreateDescription, onUploadImageClick, onUploadPdfOrWord, enviarAudio, existeComponente }: CreateNewTypeComponentProps) {
    const [menu, setMenu] = useState<boolean>(false);
    const menuRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (menu && menuRef.current) {
            menuRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }, [menu]);

    function handleClick() {
        setMenu(!menu)
    }

    function handleClose() {
        setMenu(!menu)
    }

    function handleCreateTitle(event: React.MouseEvent<HTMLLIElement>) {
        event.preventDefault()
        onCreateTitle('titulo')
        handleClose()
    }

    function handleCreateDescription(event: React.MouseEvent<HTMLLIElement>) {
        event.preventDefault()
        onCreateDescription('texto')
        handleClose()
    }

    function handleUplaodImage(event: React.MouseEvent<HTMLLIElement>) {
        event.preventDefault()
        onUploadImageClick('img')
        handleClose()
    }

    function handleUplaodPdfOrWord(event: React.MouseEvent<HTMLLIElement>) {
        event.preventDefault()
        onUploadPdfOrWord('pdf')
        handleClose()
    }

    function lidarComEnvioAudio(event: React.MouseEvent<HTMLLIElement>) {
        event.preventDefault()
        console.log('enviar audio')
        enviarAudio('audio')
        handleClose()
    }

    return (
        <div className={styles.container_create_new_type_component}>
            <div className={styles.select_new_type}>
                <div className={styles.button_container}>
                    <Button
                        className={styles.add_briefing}
                        onClick={handleClick}
                        variant='contained'
                        startIcon={<AddIcon />}
                    >
                        {existeComponente ? 'NOVA INFORMAÇÃO' : 'CRIAR NOVO BRIEFING'}
                    </Button>
                </div>

                {
                    menu &&
                    (
                        <div ref={menuRef} className={styles.container_menu}>
                            <ul>
                                <li onClick={handleCreateTitle}>Título</li>
                                <li onClick={handleCreateDescription}>Texto</li>
                                <li onClick={handleUplaodImage}>Imagens</li>
                                <li onClick={handleUplaodPdfOrWord}>PDF ou Word</li>
                                <li onClick={lidarComEnvioAudio}>Audio</li>
                            </ul>
                        </div>
                    )
                }
            </div>
        </div>
    )
}